/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { DialogStack } from 'apmui/components/dialog/Model';

interface IHeaderModel {
    logoImage: string;
    logoSmallImage: string;
    mottoMessage: string;
    disconnectCaption: string;
    maxTimeoutTitle?: string;
    settingsIcon?: string;
    settingsLabel?: string;
    showControls?: boolean;
    showSettings?: boolean;
}

interface IGeneralUIModel {
    /**
     * Header Config
     */
    header: IHeaderModel;
    /**
     * Footer Config
     */
    footer: {
        message: string;
    };
    /**
     * Page config
     */
    config: {
        pageTitle?: string;
        backgroundColor: string;
        landingUri?: string;
        landingUriBase64?: string;
        layoutBreakpointSmall: string;
        layoutBreakpointLarge: string;
        disableExternalData: 'on' | 'off';
    };
    /**
     * Advanced Customization Images
     */
    images?: {
        image00: string;
        image01: string;
        image02: string;
        image03: string;
        image04: string;
        image05: string;
        image06: string;
        image07: string;
        image08: string;
        image09: string;
    };
    /**
     * Splash Text
     */
    splash?: {
        display: boolean;
        text: string;
    };
    /**
     * Controllers list
     */
    controllers: {
        policyTimeout: boolean;
    };
    /**
     * policyTimeout data
     */
    policyTimeout: {
        message: string;
        newSessionMessage: string;
    };
}

/**
 * Common page configuration data
 */
interface ITemplateModel {
    /**
     * Page type tag
     */
    pageType: string;

    /**
     * Advanced Customization script files
     */
    scripts: string[];

    /**
     * Advanced Customization style files
     */
    styles: string[];

    /**
     * Modal dialog data
     */
    dialogs: DialogStack;

    /**
     * General UI properties (common for all pages)
     */
    general: IGeneralUIModel;
}

export { ITemplateModel as default, IGeneralUIModel, IHeaderModel };
